export default function DirectAnswerBlock() {
  return <section id="direct-answer-block" className="bg-card py-12 md:py-16 border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl text-center">
        <p className="text-card-foreground text-lg md:text-xl leading-relaxed font-default">
          A marine equipment nameplate is a durable identification plate on marine or aerospace equipment, often produced to MIL-SPEC requirements such as MIL-DTL-15024. Evermark Industrial Solutions produces MIL-SPEC phenolic and metal nameplates and direct part marking for marine and aerospace OEMs — designed to align with the specified standard, with serialization and traceability when the program requires it.
        </p>
      </div>
    </section>;
}